export const AUTH_USER_TOKEN_KEY = "Roots.TokenKey";



// WEBPACK FOOTER //
// ./src/Utils/LocalStorage.ts